import { c as _c } from "react/compiler-runtime";
export const HeroIcon = t0 => {
  const $ = _c(16);
  const {
    size,
    heroId,
    variant: t1,
    className
  } = t0;
  const variant = t1 === undefined ? "sb" : t1;
  if (!heroId) {
    let t2;
    if ($[0] !== size) {
      t2 = {
        width: size,
        height: size
      };
      $[0] = size;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    const t3 = `bg-muted flex items-center justify-center ${className}`;
    let t4;
    if ($[2] !== t2 || $[3] !== t3) {
      t4 = <div style={t2} className={t3} />;
      $[2] = t2;
      $[3] = t3;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    return t4;
  }
  const t2 = String(heroId);
  let t3;
  if ($[5] !== t2) {
    t3 = t2.replace("npc_dota_hero_", "");
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const cleanHeroId = t3;
  let suffix;
  bb0: switch (variant) {
    case "icon":
      {
        suffix = "icon.png";
        break bb0;
      }
    case "landscape":
      {
        suffix = "lg.png";
        break bb0;
      }
    case "portrait":
      {
        suffix = "vert.jpg";
        break bb0;
      }
    case "sb":
    default:
      {
        suffix = "sb.png";
      }
  }
  const t4 = `Hero Icon ${cleanHeroId}`;
  const t5 = variant === "sb" ? `${1.8 * size}px` : `${size}px`;
  const t6 = `${size}px`;
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = {
      objectFit: "contain",
      width: t5,
      height: t6
    };
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = `https://steamcdn-a.akamaihd.net/apps/dota2/images/heroes/${cleanHeroId}_${suffix}`;
  let t9;
  if ($[10] !== className || $[11] !== size || $[12] !== t4 || $[13] !== t7 || $[14] !== t8) {
    t9 = <img alt={t4} width={size} height={size} style={t7} className={className} src={t8} />;
    $[10] = className;
    $[11] = size;
    $[12] = t4;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};